export function clickTagsNames(
  event: React.MouseEvent,
  tagsNames: string[],
  onClick?: () => void,
) {
  const { tagName } = event.target as HTMLElement;
  if (tagsNames.includes(tagName) === false && onClick) {
    onClick();
  }
}
